import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from "./../Container";
import { Paper } from "./../Paper";
import { Contact } from "../icons";
import styled from "@emotion/styled";
import { Map } from "./Map";
import { useElementsContext } from "../elementsProvider";
import { EmailInformation } from "./EmailInformation";
export function RTCContactCard({ colorTexts, colorTitle, email, query, phoneNumber, subtitle, title, typographyTexts, typographyTitle, }) {
    const { isMobile } = useElementsContext();
    const hasMap = query !== "";
    const shouldShowInfo = title !== "" || subtitle !== "" || email !== "" || phoneNumber !== "";
    return (_jsx(Container, { children: _jsxs(PaperStyled, Object.assign({ shouldShowInfo: shouldShowInfo, hasMap: hasMap, isDesktop: !isMobile }, { children: [shouldShowInfo && (_jsxs(ContactContainer, Object.assign({ hasMap: hasMap, isDesktop: !isMobile }, { children: [(title !== "" || subtitle !== "") && (_jsxs(TitleContainer, Object.assign({ isDesktop: !isMobile, hasMap: hasMap }, { children: [_jsx(ContactTitle, Object.assign({ typographyTitle: typographyTitle, colorTitle: colorTitle, isDesktop: !isMobile }, { children: title }), void 0),
                                _jsx(ContactSubTitle, Object.assign({ typographyTexts: typographyTexts, colorTexts: colorTexts, isDesktop: !isMobile }, { children: subtitle }), void 0)] }), void 0)),
                        email !== "" && (_jsx(EmailInformation, { isDesktop: !isMobile, colorText: colorTexts, typographyText: typographyTexts, email: email, hasMap: hasMap }, void 0)),
                        phoneNumber !== "" && (_jsxs(IconContainer, Object.assign({ isDesktop: !isMobile }, { children: [_jsx(ContactIcon, Object.assign({ colorTexts: colorTexts, isDesktop: !isMobile }, { children: _jsx(Contact, {}, void 0) }), void 0),
                                _jsx(ContactInfo, Object.assign({ typographyTexts: typographyTexts, colorTexts: colorTexts, isDesktop: !isMobile }, { children: _jsx(LinkTo, Object.assign({ colorTexts: colorTexts, href: `tel:${phoneNumber}` }, { children: phoneNumber }), void 0) }), void 0)] }), void 0))] }), void 0)),
                hasMap && _jsx(Map, { query: query }, void 0)] }), void 0) }, void 0));
}
const PaperStyled = styled(Paper)(({ shouldShowInfo, hasMap, isDesktop }) => (Object.assign({ display: "grid" }, (isDesktop
    ? {
        alignItems: "center",
        gridAutoFlow: "column",
        gridTemplateColumns: shouldShowInfo && hasMap ? "calc(100% - 44.6rem) 44.6rem" : "1fr",
        justifyContent: shouldShowInfo && hasMap ? "space-between" : "center",
        padding: shouldShowInfo && hasMap ? "2rem 2.4rem" : 0,
    }
    : {}))));
const ContactContainer = styled.div(({ hasMap, isDesktop }) => (Object.assign({ alignItems: "center", padding: "4rem 1.6rem 0.8rem 2.4rem", maxWidth: "32rem" }, (isDesktop
    ? {
        alignItems: hasMap ? "flex-start" : "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "2rem 2.4rem",
        maxWidth: "none",
    }
    : {}))));
const TitleContainer = styled.div(({ isDesktop, hasMap }) => (Object.assign({ marginBottom: "4rem", textAlign: hasMap ? "left" : "center" }, (isDesktop
    ? {
        marginBottom: "5.2rem",
    }
    : {}))));
const ContactTitle = styled.h2(({ typographyTitle, colorTitle, isDesktop }) => (Object.assign({ color: colorTitle, fontFamily: typographyTitle, fontSize: "2.4rem", marginBottom: 2, marginTop: 0, wordBreak: "break-word" }, (isDesktop
    ? {
        fontSize: "3rem",
    }
    : {}))));
const ContactSubTitle = styled.p(({ typographyTexts, colorTexts, isDesktop }) => (Object.assign({ color: colorTexts, fontFamily: typographyTexts, fontSize: "1.4rem", marginBottom: 0, marginTop: 2, wordBreak: "break-word" }, (isDesktop
    ? {
        fontSize: "1.6rem",
    }
    : {}))));
const IconContainer = styled.div(({ isDesktop }) => (Object.assign({ alignItems: "center", display: "flex", justifyContent: "flex-start", marginBottom: "3.2rem" }, (isDesktop
    ? {
        marginBottom: 0,
    }
    : {}))));
const ContactInfo = styled.p(({ typographyTexts, colorTexts, isDesktop }) => (Object.assign({ color: colorTexts, fontFamily: typographyTexts, fontSize: "1.6rem", margin: "0 0.8rem", wordBreak: "break-all", maxWidth: "100%" }, (isDesktop
    ? {
        margin: "1.2rem 1.6rem",
    }
    : {}))));
const ContactIcon = styled.span(({ colorTexts, isDesktop }) => ({
    "& svg": Object.assign({ color: colorTexts, fontSize: "2rem" }, (isDesktop
        ? {
            fontSize: "2.4rem",
        }
        : {})),
}));
const LinkTo = styled.a(({ colorTexts }) => ({
    color: colorTexts,
    textDecoration: "none",
}));
//# sourceMappingURL=RTCContactCard.js.map